import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { ContentHeaders } from '../../common/headers';
import { LoginModel } from '../../models/login.model';
import { AppSettings } from '../../common/app.settings';
import { PrivilegesService } from '../../services/privileges.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
  providers: [PrivilegesService]
})
export class LogoutComponent {
  constructor(private router: Router,
    private http: Http,
    private privilegesService: PrivilegesService,
    private authService: AuthenticationService) { }

  ngOnInit() {
    this.privilegesService.logOut();
    this.authService.logout();
    this.http.post(AppSettings.apiEndPoint + '/logout', { headers: ContentHeaders })
      .subscribe(
        response => {
        },
        error => {
        }
      );
    this.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/logout/logout.component.ts